import { useSyncExternalStore } from "react"
import { isAppOutdated, subscribeAppOutdated } from "@/lib/app-version"

/** True once the server reports a newer frontend build than this tab runs. */
export function useAppOutdated(): boolean {
  return useSyncExternalStore(subscribeAppOutdated, isAppOutdated, () => false)
}
